var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmarkCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 22.5C5.81294 22.5 1 17.6871 1 11.75C1 5.81294 5.81294 1 11.75 1C17.6871 1 22.5 5.81294 22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5ZM16.1901 9.64829C16.6861 9.40536 16.8912 8.80634 16.6483 8.31036C16.4053 7.81437 15.8063 7.60923 15.3103 7.85216C13.3545 8.81011 11.8402 10.4539 10.8372 11.7938C10.4896 12.2581 10.1962 12.6957 9.96026 13.071C9.68112 12.8292 9.40583 12.6289 9.16316 12.4689C8.88562 12.2859 8.63935 12.1481 8.45963 12.0548C8.36951 12.008 8.29538 11.9719 8.24153 11.9466C8.21458 11.934 8.19265 11.924 8.17625 11.9166L8.15586 11.9076L8.14888 11.9046L8.14622 11.9034L8.14412 11.9025C8.14388 11.9024 8.14412 11.9025 7.7502 12.8217L8.14412 11.9025C7.63649 11.685 7.04861 11.9201 6.83106 12.4277C6.61392 12.9344 6.84809 13.5211 7.3537 13.7397L7.35473 13.7401L7.35829 13.7417C7.3643 13.7444 7.37547 13.7495 7.3913 13.7569C7.423 13.7718 7.47309 13.7961 7.53765 13.8296C7.66731 13.897 7.85228 14.0002 8.06224 14.1387C8.49104 14.4214 8.97956 14.8217 9.33097 15.3237C9.53389 15.6136 9.8749 15.7746 10.2277 15.7472C10.5803 15.7198 10.8924 15.5078 11.0482 15.1902L11.0508 15.1851L11.0653 15.1563C11.079 15.1295 11.1005 15.0879 11.1297 15.0332C11.1882 14.9235 11.2772 14.7614 11.3954 14.56C11.6323 14.1564 11.9838 13.5994 12.4382 12.9924C13.3602 11.7609 14.6459 10.4046 16.1901 9.64829Z",
    fill: "#16A34A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkCircleIcon);
export default __webpack_public_path__ + "static/media/green-checkmark-circle-icon.3713f725373e3fa63fd8411d380e6668.svg";
export { ForwardRef as ReactComponent };